<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/sXyTv9/tc-custom/9781612833088.jpg?1701060944604" alt="This image is the cover for the book UFOs, ETs, and Alien Abductions"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">UFOs, ETs, and Alien Abductions
      </h1>
      <p class="bookDescription body article font2">
        <b>“A splendid book compiling the extensive evidence justifying his courageous and clear conclusion that some UFOs are extraterrestrial spacecraft.” —Stanton T. Friedman, author of <i>Flying Saucers and Science</i></b><br/><br/>Psychologist and researcher Don Donderi examines the evidence and research from the past several decades on the changing nature of UFOs. He looks at why the scientific establishment takes a dim view of UFOs and abduction evidence and examines how the US government has collected and suppressed UFO evidence.<br/><br/><i>UFOs, ETs, and Alien Abductions</i> is a wide-ranging examination of all things off-planet that falls into three sections . . . UFOs: evidence and belief between 1947 through 1965 and Cold War mysteriesThe changing nature of UFO phenomenon from 1965 to the present, which makes the case for the existence of humanoid crew members seen in and around landed UFOs. This section also examines six well-documented abduction cases, and includes the author detailing his own research involvement with the evidence. He refutes the belief that all abductees are mentally disturbed and that a psychological disturbance explains the experience.The third section is devoted to a very meaty and controversial analysis of science, politics, and UFOs.<br/><br/>“An excellent study of the UFO phenomenon and the scientific community’s reaction to it.” —David M. Jacobs, author of <i>The Threat: Revealing the Secret Alien Agenda</i><br/><br/>“A bold summation of the case for extraterrestrial UFOs, which explains why science has rejected these data and tells us how the UFO phenomenon is potentially important for all mankind.” —Mark Rodeghier, president and scientific director of the J. Allen Hynek Center for UFO Studies
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Don Donderi
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Hampton Roads Publishing Company, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?73318558